const CacheManagerProvider = () => {
  console.log('Video');
};

const LFUPolicy = () => {
  console.log('VideoRef');
};

const useProxyCacheManager = () => {
  console.log('ReactVideoSource');
  const cacheManager = CacheManagerProvider();

  return{
      cacheManager
  }
};

export { CacheManagerProvider, LFUPolicy, useProxyCacheManager };
